import { useMutation, useQueryClient } from '@tanstack/react-query';
import { managedLighthouseQueryKeys, networkQueryKeys, Networks } from '#api';
import { makeNetworkQueryOptions } from '#api/networks.queries.ts';

export function useDeleteNetworkMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (networkId: string) => Networks.deleteNetwork(networkId),
    onSuccess: (data, networkId) => {
      const networkQueryOptions = makeNetworkQueryOptions(networkId);
      queryClient.removeQueries({ ...networkQueryOptions, exact: true });
      void queryClient.invalidateQueries({ queryKey: networkQueryKeys.lists() });
      // Deleting a network deletes its managed-lighthouse tenancy with it.
      void queryClient.invalidateQueries({ queryKey: managedLighthouseQueryKeys.all() });
    },
  });
}
